import angular, { isNumber } from "angular";

import "../../../services/user";
import "../../../services/countries";
import * as dawaAutocomplete from "dawa-autocomplete2";

angular.module("folkeuni").component("userCreate", {
  templateUrl: "/shop-dist/templates/user-create.html?c=" + window.cacheBurst,
  transclude: false,
  bindings: {
    departmentId: "@",
  },
  controller: function (Countries, User, $sce, $scope, $timeout, $element) {
    var $ctrl = this;

    $ctrl.countries = [];
    $ctrl.errorTimer = null;

    $ctrl.user = {
      email: "",
      firstName: "",
      middleName: "",
      lastName: "",
      streetName: "",
      streetNumber: "",
      floorNumber: "",
      side: "",
      roomNumber: "",
      phoneNumber: "",
      postalCode: "",
      city: "",
      country: "DK",
      password: "",
      passwordConfirmed: "",
    };

    $ctrl.$onInit = function () {
      //Getting data ready for the form;
      $ctrl.countries = Countries.getAll;
      $ctrl.user.siteId = $ctrl.departmentId;

      $timeout(function () {
        var streetnameInput = $element[0].querySelector(
          'input[ng-model="$ctrl.user.streetname"]'
        );
        if (streetnameInput) {
          dawaAutocomplete.dawaAutocomplete(streetnameInput, {
            select: function (selected) {
              $scope.$apply(function () {
                $scope.$ctrl.user.streetNumber = selected.data.husnr;
                $timeout(function () {
                  $scope.$ctrl.user.streetname = selected.data.vejnavn;
                }, 100);
                $scope.$ctrl.user.postalCode = Number(selected.data.postnr);
                $scope.$ctrl.user.city = selected.data.postnrnavn;
                $scope.$ctrl.user.floor = selected.data.etage;
                if (
                  selected.data.dør != null &&
                  !isNaN(Number(selected.data.dør))
                ) {
                  $scope.$ctrl.user.roomNumber = Number(selected.data.dør);
                  $scope.$ctrl.user.side = null;
                } else {
                  $scope.$ctrl.user.side = selected.data.dør || "";
                  $scope.$ctrl.user.roomNumber = "";
                }

                $timeout(function () {
                  streetnameInput.value = $scope.$ctrl.user.streetname;
                }, 150);
              });
            },
          });
        } else {
          console.error("Streetname input not found.");
        }
      }, 0);
    };

    $ctrl.passwordConfirmValid = function () {
      return (
        $ctrl.user.passwordConfirmed == "" ||
        $scope.editUserForm.userPasswordConfirmed.$pristine ||
        $ctrl.user.password == $ctrl.user.passwordConfirmed
      );
    };

    // Submit user details
    $ctrl.userCreate = function (formData) {
      $ctrl.loading = true;
      $ctrl.statusMessage = null;
      $timeout.cancel($ctrl.ErrorTimer);

      if (!$scope.editUserForm.$valid) {
        $ctrl.loading = false;

        return;
      } else {
        var newUser = Object.assign({}, $ctrl.user);

        if (isNumber($ctrl.user.phoneNumber)) {
          newUser.phoneNumber = $ctrl.user.phoneNumber.toString();
        }

        User.create(newUser).then(
          function (successResponse) {
            $ctrl.statusMessage =
              "Din bruger er nu oprettet og du vil modtage en email med et aktiverings-link.";
            $ctrl.created = true;
            $ctrl.formFade = false;
            $ctrl.loading = false;
            $timeout(function () {
              $ctrl.statusMessage = null;
            }, 5000);
          },
          function (errorResponse) {
            $ctrl.formFade = false;
            $ctrl.rejected = true;

            $ctrl.loading = false;
            if (errorResponse.status == 409) {
              $ctrl.statusMessage = $sce.trustAsHtml(
                "Der er allerede oprettet en bruger med denne e-mailadresse. Har du glemt dit password, <a href='/login/dan-nyt-password/?email=" +
                  $ctrl.user.email +
                  "'>kan du forsøge at nulstille dit password</a>."
              );
              $ctrl.ErrorTimer = $timeout(function () {
                $ctrl.statusMessage = null;
              }, 5000);
            }
          }
        );
      }
    };
  },
});
